{
  "error": "Erreur",
  "loading": "...",
  "newUser": "Nouvel utilisateur",
  "newUserGroup": "Nouveau groupe"
}
